import React, { useState } from "react";

// components
import SalesTab from "./SalesTab";
import AppointmentTab from "./AppointmentTab";
import GroupTab from "./GroupTab";

const TABS = [
  { value: 0, label: "영업 커미션" },
  { value: 1, label: "개인레슨 수당" },
  { value: 2, label: "그룹수업 수당" },
];

const Tabs = ({ tabDetails }: any) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="tab-header">
        {TABS.map((tab) => {
          return (
            <div
              key={tab.value}
              className={`tab ${activeTab === tab.value ? " active" : ""}`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </div>
          );
        })}
      </div>

      {activeTab === 0 && <SalesTab details={tabDetails?.payrollCommission} />}
      {activeTab === 1 && <AppointmentTab details={tabDetails?.personalPayrollAllowance} />}
      {activeTab === 2 && <GroupTab details={tabDetails?.groupPayrollAllowance} />}
    </>
  );
};

export default Tabs;
